var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8284 17.8284C23.5786 17.0783 24 16.0609 24 15C24 13.9391 23.5786 12.9217 22.8284 12.1716C22.0783 11.4214 21.0609 11 20 11C18.9391 11 17.9217 11.4214 17.1716 12.1716C16.4214 12.9217 16 13.9391 16 15C16 16.0609 16.4214 17.0783 17.1716 17.8284C17.9217 18.5786 18.9391 19 20 19C21.0609 19 22.0783 18.5786 22.8284 17.8284Z",
    stroke: "#AEC6E8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0503 24.0503C16.363 22.7375 18.1435 22 20 22C21.8565 22 23.637 22.7375 24.9497 24.0503C26.2625 25.363 27 27.1435 27 29H13C13 27.1435 13.7375 25.363 15.0503 24.0503Z",
    stroke: "#AEC6E8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu5);
export default __webpack_public_path__ + "static/media/menu-5.eac1804628bd2f3e7988ddb9405c2666.svg";
export { ForwardRef as ReactComponent };